import { AudioTile } from './tile.audio.js';
import { ImageTile } from './tile.image.js';
import { TextTile } from './tile.text.js';
import { jsx } from 'react/jsx-runtime';

function Tile(props) {
  switch (props.tile.type) {
    case "Audio":
      return /*#__PURE__*/jsx(AudioTile, {
        ...props,
        ...props.tile
      });
    case "Image":
      return /*#__PURE__*/jsx(ImageTile, {
        ...props,
        ...props.tile
      });
    case "Text":
      return /*#__PURE__*/jsx(TextTile, {
        ...props,
        ...props.tile
      });
  }
}

export { Tile };
//# sourceMappingURL=_tile-input.js.map
